import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { $$ } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { ApplicationInformation, ApplicationInformationService, WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { renderJsx } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Control";
import { ControlRef } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ControlRef";
import { Application } from "./Application";
import { registerAppAsync } from "./Registration";

import "./Ui/Styles/Theme.scss";

const
    radWindow = WindowShim();

ServiceManager.add(ApplicationInformationService, Object.assign(new ApplicationInformation(), radWindow.applicationInformation));

$$(document).on("launchapplication", async () =>
{
    const
        application = new ControlRef<Application>(),
        configuration: Configuration = {
            pageManager: {
                detailsPageMap: {},
                indexPageMap: {},
                routes: {},
            }
        };

    await registerAppAsync(configuration);

    renderJsx(
        <Application ref={application} loginWithDialog={true} configuration={configuration} />,
        document.body
    );
});
